import React from 'react'
import {css} from '@emotion/react'
import {Table, TableBody, TableCell, TableRow} from '@mui/material'

import Paper from '../../../../components/elements/Paper'
import CopyButton from '../../../../components/modules/DataExportControl/CopyButton'


function ColorTable({rows, ...props}) {
  const styles = {
    root: css`
      padding: 16px;
    `,

    row: css`
      
    `,

    cellTitle: css`
      padding: 8px;
      font-size: 1rem;
      font-weight: 600;
    `,

    cellValue: css`
      padding: 8px;
      
      display: flex;
      align-items: center;
      gap: 8px;
    `,

    copy: css`
      margin-left: 4px;
    `
  }

  return (
    <Paper css={styles.root} {...props}>
      <Table size="small">
        <TableBody>
          {rows.map((row) => (
            <TableRow css={styles.row} key={row.label}>
              <TableCell css={styles.cellTitle}>{row.label}</TableCell>
              <TableCell css={styles.cellValue} align="right">
                <div css={styles.value}>
                  {row.value}
                  <CopyButton css={styles.copy} disabled={!row.value} iconMode data={row.value}/>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  )
}

export default React.memo(ColorTable)
